import { render, staticRenderFns } from "./ArticlesSearchInput.vue?vue&type=template&id=4e9a5c51&scoped=true"
import script from "./ArticlesSearchInput.vue?vue&type=script&lang=ts"
export * from "./ArticlesSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a5c51",
  null
  
)

export default component.exports